module.exports = __webpack_public_path__ + "files/741e780f55d3caaf4905dcc98783d752.png";